// @ts-nocheck

import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Tokens as getToken } from '../../api/swap'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router-dom'
import formatLongNumber from '../../utils/formatLongNumber'
import axios from 'axios'
import nodata from '../../assets/images/knodata.png'
import multiply from '../../utils/multiply'
import thousandsSeparator from '../../utils/thousandsSeparator'

const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #fff;
  padding: 22px 52px 22px 25px;
  margin-bottom: 10px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.68);
  }
  .item-left {
    display: flex;
    align-items: center;
    .key {
      font-weight: 400;
      font-size: 20px;
      color: #181818;
      margin-right: 38px;
    }
    .left-box {
      display: flex;
      flex-direction: column;
      .box {
        display: flex;
        gap: 18px;
        .data {
          margin-top: 10px;
          display: flex;
          align-items: center;
          div {
            font-weight: 500;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.6);
          }
          .pole {
          }
        }
        .volume {
          margin-top: 10px;
          font-weight: 400;
          color: #181818;
          font-size: 16px;
          span {
            font-weight: 600;
            color: #181818;
          }
        }
      }
      .price {
        font-weight: 500;
        font-size: 20px;
        color: #181818;
      }
    }
  }
  .item-center {
  }
  .item-right {
    .token {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 5px;
      text-align: end;
      span {
        font-weight: 400;
        font-size: 14px;
        color: #181818;
        opacity: 0.6;
      }
      img {
        width: 16px;
        border-radius: 50%;
      }
    }
    .token-name {
      margin-top: 10px;
      font-weight: 700;
      color: #181818;
      text-align: end;
      font-size: 20px;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 90px;
    }
  }

  @media (max-width: 768px) {
    padding: 12px 14px;
    margin-bottom: 6px;
    .item-left {
      flex: 2;
      display: block;
      .key {
        display: none;
      }
      .left-box {
        .box {
          display: block;
          .data {
            margin-top: 10px;
            div {
              font-size: 12px;
              font-weight: 600;
            }
          }
          .volume {
            font-size: 13px;
          }
        }
        .price {
          font-weight: 700;
          font-size: 16px;
        }
      }
    }
    .chart {
      flex: 0.8;
      img {
        width: 100%;
      }
    }
    .item-right {
      flex: 1;

      .token {
        span {
          font-size: 11px;
        }
        img {
          width: 20px;
        }
      }
      .token-name {
        margin-top: 6px;
        font-size: 16px;
      }
    }
  }
`

export default function TokensMobileList() {
  const history = useHistory()

  const [list, setList] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getToken()
        setList(data)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    window.scrollTo(0, 0)
    fetchData()
  }, [])

  let [jsonData, setJsonData] = useState([])

  async function getJson() {
    try {
      let data = await axios.get('https://website.bjwmls.com/static/tokenlist.json')
      setJsonData(data.data.tokens)
    } catch (error) {}
  }

  function getLogoURIByAddress(address) {
    const lowerCaseAddress = address.toLowerCase()
    // console.log(jsonData)

    const foundItem = jsonData?.find(item => item.address.toLowerCase() === lowerCaseAddress)

    return foundItem ? foundItem.logoURI : null
  }

  useEffect(() => {
    getJson()
  }, [])

  function jump(token) {
    history.push('/explore/tokens/' + token)
  }
  function addBeforeDash(str) {
    if (str > 0) {
      return '+' + str
    } else {
      return str.toString()
    }
  }

  return (
    <div className="list" style={{ marginTop: '16px' }}>
      {list.map((item, index) => {
        return (
          <Item key={index} onClick={() => jump(item.contract)}>
            <div className="item-left">
              <div className="key">{index + 1 <= 9 ? '0' + (index + 1) : index + 1}</div>
              <div className="left-box">
                <div className="price">¥{thousandsSeparator(multiply(item?.price))}</div>
                <div className="box">
                  <div className="data">
                    <div>
                      H{' '}
                      <span style={{ color: item['h1'] < 0 ? '#E65262' : '#12B298' }}>
                        {thousandsSeparator(addBeforeDash(formatLongNumber(parseFloat(item['h1'] * 100), 2)))}%
                      </span>
                      | D{' '}
                      <span style={{ color: item['d1'] < 0 ? '#E65262' : '#12B298' }}>
                        {thousandsSeparator(addBeforeDash(formatLongNumber(parseFloat(item['d1'] * 100), 2)))}%
                      </span>
                    </div>
                  </div>
                  <div className="volume">
                    Volume :<span>¥{thousandsSeparator(item.volume)}</span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="chart">
              {item.price > 0 ? <img src={`/kl/${item.contract}_1d.svg`} /> : <img src={nodata} width={124} />}
            </div> */}

            <div className="item-right">
              <div className="token">
                <span>{item.symbol}</span>
                {getLogoURIByAddress(item.contract) && <img src={getLogoURIByAddress(item.contract)} />}
              </div>
              <div className="token-name">{item.name}</div>
            </div>
          </Item>
        )
      })}
    </div>
  )
}
